import { createSlice } from "@reduxjs/toolkit";
import { BusinessType } from "./types";
const initialState = {
    initialized: false,
    businessType: BusinessType.Retail,
};
const slice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setAppInitialized: (state, action) => {
            state.initialized = action.payload;
        },
        setBusinessType: (state, action) => {
            state.businessType = action.payload;
        },
        setCurrentCity: (state, action) => {
            state.currentCity = action.payload;
        },
        setCurrentSubject: (state, action) => {
            state.currentSubject = action.payload;
        },
    },
});
export const { setAppInitialized, setBusinessType, setCurrentCity, setCurrentSubject, } = slice.actions;
export default slice.reducer;
